import { defineStore } from "pinia";

import type { PatientsPoolState } from "./Models/State";
import type { PatientPool } from "../Models/Domain/PatientsPool";
import { StateNamespace } from "@/Modules/App/Models/State/StateNamespace";

import getPatientsAH from "@/Modules/PatientsPool/ActionHandlers/GetPatients";
import assigmentPatientAH from "@/Modules/PatientsPool/ActionHandlers/AssigmentPatient";

import { hasValue } from "@/Utils/Objects";

const patientsPoolState: PatientsPoolState = {
  isLoading: false,
  notification: null,
  patientsPool: null,
};

export const usePatientsPoolStore = defineStore(StateNamespace.PATIENTS_POOL, {
  state: () => ({ ...patientsPoolState }),
  getters: {
    getNumberPatientsList(state: PatientsPoolState): number {
      if (hasValue(state.patientsPool)) {
        return state.patientsPool.length;
      }

      return 0;
    },

    getPatientsList(state): PatientPool[] {
      if (!hasValue(state.patientsPool) || !Array.isArray(state.patientsPool)) return [];

      return state.patientsPool;
    },
  },

  actions: {
    getPatientsPoolList(userUuid: string) {
      getPatientsAH(userUuid);
    },

    postAssigmentPatient(customerUuid: string) {
      return assigmentPatientAH(customerUuid);
    },

    addPatient(patient: PatientPool) {
      const list = this.getPatientsList;
      const patientIndex = list.findIndex((p) => p.customerUuid === patient.customerUuid);

      if (patientIndex >= 0) {
        list[patientIndex] = patient;
      } else {
        list.push(patient);
      }

      this.patientsPool = list;
    },

    removePatient(uuid: string) {
      this.patientsPool = this.getPatientsList.filter((p) => p.customerUuid !== uuid);
    },
  },
});

export type PatientsPoolStore = ReturnType<typeof usePatientsPoolStore>;

export default usePatientsPoolStore;
